__turbopack_context__.v({
  "container": "ApplyLayout-module__SBYI_a__container",
  "fadeInItems": "ApplyLayout-module__SBYI_a__fadeInItems",
  "spacing--lg": "ApplyLayout-module__SBYI_a__spacing--lg",
  "spacing--md": "ApplyLayout-module__SBYI_a__spacing--md",
  "spacing--sm": "ApplyLayout-module__SBYI_a__spacing--sm",
  "spacing--xl": "ApplyLayout-module__SBYI_a__spacing--xl",
  "spacing--xs": "ApplyLayout-module__SBYI_a__spacing--xs",
  "spacing--xxl": "ApplyLayout-module__SBYI_a__spacing--xxl",
  "spacing--xxs": "ApplyLayout-module__SBYI_a__spacing--xxs",
  "spacing--xxxl": "ApplyLayout-module__SBYI_a__spacing--xxxl",
  "spacing--xxxs": "ApplyLayout-module__SBYI_a__spacing--xxxs",
});
